import {Component, Input, OnInit} from "@angular/core";

import {DirectorySearchTabConfigModel} from "../../models/directory-search-tab-config.model";
import {DirectorySearchForm} from "../../forms/directory-search.form";
import {AggregationGroupModel} from "../../../../models/aggregation-group.model";
import {SearchFilterMetadataModel} from "../../../../models/search-filter-metadata.model";

@Component({
    selector: "pcg-ng-directory-search-filters",
    template: require('./directory-search-filters.component.html')
})
export class DirectorySearchFiltersComponent implements OnInit {
    @Input()
    public searchConfig: DirectorySearchTabConfigModel;

    @Input()
    public searchForm: DirectorySearchForm;

    public categories: AggregationGroupModel;
    public eventCategories: AggregationGroupModel;
    public needsOfChildren: AggregationGroupModel;
    public postcodes: AggregationGroupModel;
    public age: AggregationGroupModel;
    public frequency: AggregationGroupModel;
    public dietaryNeeds: AggregationGroupModel;
    public accessibility: AggregationGroupModel;
    public provisionTypes: AggregationGroupModel;
    public schoolNeeds: AggregationGroupModel;
    public specialDietCater: AggregationGroupModel;

    public constructor() { }

    private static mapFilterToAggregation(filter: SearchFilterMetadataModel, value: Array<string> = []): AggregationGroupModel {
        const aggregation = {
            expanded: (value && (value.length > 0)),
            title: filter.caption,
            name: filter.alias,
            items: filter.attributes.map(attribute => {
                return {
                    selected: (value.indexOf(attribute.id) > -1),
                    expanded: false,
                    title: attribute.name,
                    value: attribute.id,
                    count: 0,
                    subcategories: attribute.nestedAttributes
                        ? attribute.nestedAttributes.map(nestedAttribute => {
                            return {
                                selected: (value.indexOf(nestedAttribute.id) > -1),
                                expanded: false,
                                title: nestedAttribute.name,
                                value: nestedAttribute.id,
                                count: 0,
                                subcategories: null
                            };
                        })
                        : null,
                };
            })
        } as AggregationGroupModel;

        aggregation.items.forEach(category => {
            category.expanded = (category.subcategories && category.subcategories.some(subcategory => subcategory.selected));
        });

        return aggregation;
    }

    public ngOnInit(): void {
        const filterAliases = [
            "categories",
            "eventCategories",
            "needsOfChildren",
            "postcodes",
            "age",
            "frequency",
            "dietaryNeeds",
            "accessibility",
            "provisionTypes",
            "schoolNeeds",
            "specialDietCater"
        ];

        for (const alias of filterAliases) {
            const filter = this.searchConfig.searchFilters.find(item => item.alias === alias);
            if (filter) {
                this[alias] = DirectorySearchFiltersComponent.mapFilterToAggregation(filter, this.searchForm[alias].value);
            }
        }
    }
}
